module.exports = __webpack_public_path__ + "img/约牛证劵.d4b68221.png";